import _slicedToArray from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/slicedToArray";
import _defineProperty from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/defineProperty";
import _asyncToGenerator from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

import _regeneratorRuntime from "/opt/build/repo/node_modules/gatsby/node_modules/@babel/runtime/regenerator";
import { useEffect, useReducer, useRef } from 'react';
export var SYMBOL_ABORTED = Symbol('ABORTED');

var createTask = function createTask(_ref) {
  var func = _ref.func,
      dispatchRef = _ref.dispatchRef;
  var taskId = Symbol('TASK_ID');
  var abortController = null;
  return {
    func: func,
    taskId: taskId,
    runId: null,
    start: function () {
      var _start = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
        var runId,
            _len,
            args,
            _key,
            result,
            _args = arguments;

        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                if (abortController) {
                  abortController.abort();
                }

                abortController = new AbortController();
                runId = Symbol('RUN_ID');
                dispatchRef.current({
                  type: 'START',
                  taskId: taskId,
                  runId: runId
                });
                _context.prev = 4;

                for (_len = _args.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
                  args[_key] = _args[_key];
                }

                _context.next = 8;
                return func.apply(void 0, [abortController].concat(args));

              case 8:
                result = _context.sent;
                dispatchRef.current({
                  type: 'RESULT',
                  taskId: taskId,
                  runId: runId,
                  result: result
                });
                return _context.abrupt("return", result);

              case 13:
                _context.prev = 13;
                _context.t0 = _context["catch"](4);

                if (!(_context.t0.name === 'AbortError')) {
                  _context.next = 18;
                  break;
                }

                dispatchRef.current({
                  type: 'ABORT',
                  taskId: taskId,
                  runId: runId
                });
                return _context.abrupt("return", SYMBOL_ABORTED);

              case 18:
                dispatchRef.current({
                  type: 'ERROR',
                  taskId: taskId,
                  runId: runId,
                  error: _context.t0
                });
                throw _context.t0;

              case 20:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, null, [[4, 13]]);
      }));

      function start() {
        return _start.apply(this, arguments);
      }

      return start;
    }(),
    abort: function abort() {
      if (abortController) {
        abortController.abort();
        abortController = null;
      }
    },
    started: false,
    pending: true,
    aborted: false,
    error: null,
    result: null
  };
};

var reducer = function reducer(task, action) {
  switch (action.type) {
    case 'INIT':
      return createTask(action);

    case 'START':
      if (task.taskId !== action.taskId) {
        return task; // bail out
      }

      return _objectSpread(_objectSpread({}, task), {}, {
        runId: action.runId,
        started: true,
        pending: true,
        aborted: false,
        error: null,
        result: null
      });

    case 'RESULT':
      if (task.taskId !== action.taskId || task.runId !== action.runId) {
        return task; // bail out
      }

      return _objectSpread(_objectSpread({}, task), {}, {
        started: false,
        pending: false,
        result: action.result
      });

    case 'ABORT':
      if (task.taskId !== action.taskId || task.runId !== action.runId) {
        return task; // bail out
      }

      return _objectSpread(_objectSpread({}, task), {}, {
        started: false,
        aborted: true
      });

    case 'ERROR':
      if (task.taskId !== action.taskId || task.runId !== action.runId) {
        return task; // bail out
      }

      return _objectSpread(_objectSpread({}, task), {}, {
        started: false,
        pending: false,
        error: action.error
      });

    default:
      throw new Error("unknown action type: ".concat(action.type));
  }
};

export var useAsyncTask = function useAsyncTask(func) {
  var dispatchRef = useRef(function () {
    throw new Error('not initialized');
  });

  var _useReducer = useReducer(reducer, {
    func: func,
    dispatchRef: dispatchRef
  }, createTask),
      _useReducer2 = _slicedToArray(_useReducer, 2),
      task = _useReducer2[0],
      dispatch = _useReducer2[1];

  if (task.func !== func) {
    dispatch({
      type: 'INIT',
      func: func,
      dispatchRef: dispatchRef
    });
  }

  dispatchRef.current = dispatch;
  useEffect(function () {
    var cleanup = function cleanup() {
      dispatchRef.current = function () {};
    };

    return cleanup;
  }, []);
  return task;
};